export enum ServiceType {
    TAKEAWAY = 1,
    DELIVERY,
    DINEIN,
    BOOKING,
}
